// Discrete zoom stops (percent). Non-uniform on the zoom-out side so wide
// windows (multi-day infringements) get fine-grained control without
// dragging through 50 clicks. Keep 100/200/400 as exact stops — minorStepMin
// switches at those thresholds.
export const ZOOM_LEVELS = [
  10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 75, 100, 200, 400,
]
export const ZOOM_MIN = ZOOM_LEVELS[0]!
export const ZOOM_MAX = ZOOM_LEVELS[ZOOM_LEVELS.length - 1]!

/** Width of one day in the timeline at 100% zoom. */
export const GANTT_COLUMN_WIDTH_PX = 5000

export function prevZoom(z: number): number {
  for (let i = ZOOM_LEVELS.length - 1; i >= 0; i--) {
    if (ZOOM_LEVELS[i]! < z) return ZOOM_LEVELS[i]!
  }
  return ZOOM_MIN
}

export function nextZoom(z: number): number {
  for (const lvl of ZOOM_LEVELS) {
    if (lvl > z) return lvl
  }
  return ZOOM_MAX
}

/** The closest zoom at which `minutes` of timeline fit in `widthPx`, capped
 * at 100% so a short window is not blown up past the normal scale. */
export function fitZoom(minutes: number, widthPx: number): number {
  if (minutes <= 0 || widthPx <= 0) return 100
  const fitting = ZOOM_LEVELS.filter(
    zoom =>
      zoom <= 100 &&
      (minutes * GANTT_COLUMN_WIDTH_PX * zoom) / 100 / (60 * 24) <= widthPx
  )
  return fitting.length ? fitting[fitting.length - 1]! : ZOOM_MIN
}
